// extracted by mini-css-extract-plugin
export default {"wrapper":"Pay_wrapper__NZ13C","header":"Pay_header__-6jcB","formWrapper":"Pay_formWrapper__kauqv","section":"Pay_section__ZOMHU"};